export default {
  FormError: {
    parts: ['icon', 'text'],
    baseStyle: {
      text: {
        color: 'error',
        mt: '5px',
        fontSize: 'sm',
      },
    },
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
